<div class="wrapper-lg">
    <app-breadcrumbs [items]="[{ url: '/users', text: 'userslist_title' }]"></app-breadcrumbs>

    <header class="content-header">
        <h1>{{'userslist_title' | translate}}</h1>
    </header>

    <form #form="ngForm">
        <div class="row">
            <div class="form-field col">
                <app-select [options]="roles"
                            [placeholder]="'userslist_lblRole' | translate"
                            [displayProperty]="'Value'"
                            [(ngModel)]="filterRole"
                            name="filterRole"
                            (selectionChange)="filter()">
                </app-select>
            </div>

            <div class="form-field col">
                <input class="form-control"
                       [(ngModel)]="searchValue"
                       name="searchValue"
                       [placeholder]="'log_lblSearch' | translate"
                       (input)="filter()"
                       maxlength="50">
            </div>
        </div>
    </form>

    <app-table [rows]="users"
               [columns]="columns"
               [page]="page"
               [pageSize]="pageSize"
               [total]="total"
               [auto]="false"
               (pageChange)="onPage($event)"
               (sortChange)="onSort($event)">
        <ng-template #rowTemplate let-row>
            <tr>
                <td>{{row.UserName}}</td>
                <td>{{row.Name}}</td>
                <td>{{row.Surname}}</td>
                <td>{{row.Email}}</td>
                <td>{{getRoleString(row)}}</td>
                <td>{{row.Created | appDate}}</td>
                <td>{{row.LastLogin | appDate:'datetime'}}</td>
            </tr>
        </ng-template>
    </app-table>
</div>
